export default (node) => {
  const collectionListButtons = node.querySelectorAll(
    '[data-collection-list-button]'
  );

  let currentCollectionButton = node.querySelector(
    '[data-collection-list-button].active'
  );

  const handleCollectionListButton = (e) => {
    e.preventDefault();

    const currentSlider = node.querySelector(
      `[data-collection-list-sliders].active`
    );

    // check if the current element is the active one
    const currentElement = e.currentTarget;
    if (currentElement.classList.contains('active')) {
      return;
    }

    // update the currentCollectionButton
    currentElement.classList.add('active');
    currentCollectionButton.classList.remove('active');

    // update the currentCollectionButton
    currentCollectionButton = currentElement;

    // update the currentSlider
    currentSlider.classList.add('animate-fade-out');
    currentSlider.classList.remove('active');

    // show the new slider
    const newSlider = node.querySelector(
      `[data-collection-list-sliders="${currentElement.dataset.collectionListButton}"]`
    );

    // hide the other sliders
    setTimeout(() => {
      newSlider.classList.remove('hidden');
      currentSlider.classList.add('hidden');
      currentSlider.classList.add('opacity-0');
    }, 800);

    // remove animations
    setTimeout(() => {
      currentSlider.classList.remove('animate-fade-out');
      currentSlider.classList.remove('opacity-0');
      newSlider.classList.remove('animate-fade-out');
      newSlider.classList.remove('opacity-0');
    }, 800);

    newSlider.classList.add('active');
  };

  const init = () => {
    collectionListButtons.forEach((button) => {
      button.addEventListener('click', handleCollectionListButton);
    });
  };

  init();
};
